import React from 'react'
import { Form } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'

const FilterMealPlans = () => {
  const { i18n } = useS4LContext()

  const availableBoards = [
    { id: 1, name: i18n.formatMessage({ id: 'global.room-only' }), slug: 'room-only' },
    { id: 2, name: i18n.formatMessage({ id: 'global.breakfast' }), slug: 'breakfast' },
    { id: 3, name: i18n.formatMessage({ id: 'global.all-inclusive' }), slug: 'all-inclusive' },
    { id: 4, name: i18n.formatMessage({ id: 'global.half-board-included' }), slug: 'half-board' },
    { id: 5, name: i18n.formatMessage({ id: 'global.dinner' }), slug: 'dinner' },
    { id: 6, name: i18n.formatMessage({ id: 'global.lunch' }), slug: 'lunch' },
    { id: 7, name: i18n.formatMessage({ id: 'global.full-board' }), slug: 'full-board' },
    { id: 8, name: i18n.formatMessage({ id: 'global.buffet' }), slug: 'buffet' },
  ]

  const visibleBoards = availableBoards.slice(0, 5)
  const collapsedBoards = availableBoards.slice(5)

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'filter-category.meal-plan' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      {visibleBoards.map(board => (
        <Form.Label key={`board-${board.id}`}>
          {board.name}
          <Form.Checkbox name="boards" multiple trueValue={board.slug} />
        </Form.Label>
      ))}

      <Form.Collapsible
        textMore={i18n.formatMessage({ id: 'global.show-all' })}
        textLess={i18n.formatMessage({ id: 'global.show-less' })}
      >
        {collapsedBoards.map(board => (
          <Form.Label key={`board-${board.id}`}>
            {board.name}
            <Form.Checkbox name="boards" multiple trueValue={board.slug} />
          </Form.Label>
        ))}
      </Form.Collapsible>
    </Form.Fieldset>
  )
}

FilterMealPlans.displayName = 'SearchFilters.FilterMealPlans'
export default withErrorBoundary(FilterMealPlans)
